import { variantSearchResultSchema } from "@redotech/redo-model/split";
import * as z from "zod/v4";

export const searchProductVariants = {
  name: "searchProductVariants" as const,
  input: z.object({ query: z.string(), teamId: z.string() }),
  output: z.array(variantSearchResultSchema),
};
